import styles from "../orders-page.module.scss";
import { Table, Typography } from "antd";
import ordersStorage from "../../../storages/orders.storage";
import { observer } from 'mobx-react-lite';
import { useState } from "react";

function Recipients() {
  const [currentPage, setCurrentPage] = useState(1);
  return (
    <Table
      rowKey="recipient"
      className={styles['tableMiddle']}
      columns={[
        {
          title: "Recipient",
          dataIndex: "recipient",
          key: "recipient",
          render: (value: string) => {
            return (
              <Typography>
                {value}
              </Typography>
            )
          }
        },
        {
          title: "Carrier",
          dataIndex: "carrier",
          key: "carrier",
          render: (value: string) => {
            return (
              <Typography>
                {value}
              </Typography>
            )
          }
        },
        {
          title: "Qty",
          dataIndex: "qty",
          key: "qty",
          render: (value: number, rowData) => {
            return (
              <Typography>{value}</Typography>
            )
          }
        },
        {
          title: "Orders",
          dataIndex: "orders",
          key: "orders",
          render: (value: number, rowData) => {
            return (
              <Typography>{value}</Typography>
            )
          }
        },
        {
          title: "Total",
          dataIndex: "total",
          key: "total",
          render: (value: number) => {
            return (
              <Typography>{value?.toFixed(2)}</Typography>
            )
          }
        },
      ]}
      dataSource={Object.values(ordersStorage
        .tracking
        .reduce((acc, item) => {
          const key = `${item.recipient} ${item.carrier}`;
          acc[key] = acc[key] || { recipient: item.recipient, carrier: 'unknown',qty: 0, total: 0, orders: 0 };
          acc[key].qty += 1;
          acc[key].orders += item.orders.length;
          acc[key].carrier = item.carrier;
          acc[key].total += item.orders.reduce((acc, order) => {
            return acc + order.orderTotal;
          }, 0);
          return acc;
        }, {} as Record<string, { recipient: string, carrier: string, qty: number, total: number, orders: number}>))
      }
      pagination={
        {
          position: ['bottomCenter'],
          // pageSize: 20,
          current: currentPage,
          onChange: (page) => {
            setCurrentPage(page);
          }
        }
      }
    />
  );
}

export default observer(Recipients);
